import { inject, Injectable } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { FunctionalHelpEntity } from '../functional-help.entity';
import { ConsumerEntityService } from '../../consumer/services/consumer.entity.service';
import { SubjectEntityService } from '../../subject/services/subject.entity.service';

export const STATE_NAME = 'functionalHelpEntity';

// Create the NGXS state
export const FunctionalHelpEntityState: GenericEntityStateClass<FunctionalHelpEntity> =
  createEntityState<FunctionalHelpEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class FunctionalHelpEntityService extends EntityService<FunctionalHelpEntity> {
  private consumerEntityService = inject(ConsumerEntityService);
  private subjectEntityService = inject(SubjectEntityService);

  constructor() {
    super();
    this.resourceType = 'functional-helps';
    this.stateClass = FunctionalHelpEntityState;

    this.registerRelation('consumers', this.consumerEntityService);
    this.registerRelation('subjects', this.subjectEntityService);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): FunctionalHelpEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
